module.exports = __webpack_public_path__ + "assets/images/Caixa-raquel_0c381b39e15af1c06f599e1c4118cf1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-two/Caixa-raquel.png
// module id = 204
// module chunks = 0